import React, {useState} from 'react';
import ReactSelect from 'react-select/async';
import {Etl} from '../_services/Etl';
import {User} from '../_services/User';
import {parseJSON} from '../_helpers/fetch';
import {ActivityButton} from '../components/ActivityButton';
import {Alert} from '../components/Alert';

const debounce = require('debounce-promise');

/**
 * NOTE: this does not belong here.. it should be it's own standalone app
 */

export const OnBoarding = () => {
    const handleEmailLookup = debounce(
        Etl.getInstance().employeeAutocompleter,
        250
    );

    const initiateWorkflow = () => {
        setNewEntryId(0);
        setIsSaving(true);
        fetch('/p/flow/api/onboarding', {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + User.getInstance().getAuthToken()
            },
            method: 'POST',
            body: JSON.stringify({
                employee
            })
        })
            .then(parseJSON)
            .then((response) => {
                if (response.json?.entry?.id) {
                    setNewEntryId(response.json.entry.id);
                }
            })
            .finally(() => {
                setIsSaving(false);
            })
    };

    const [step, setStep] = useState<string>('1');
    const [employee, setEmployee] = useState<any>();
    const [newEntryId, setNewEntryId] = useState<any>(0);
    const [isSaving, setIsSaving] = useState<any>(false);

    const [geids, setGeids] = useState('');
    const [isValidatingGeids, setIsValidatingGeids] = useState(false);
    const [validatedGeids, setValidatedGeids] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');

    const [isOnboarding, setIsOnboarding] = useState(false);
    const [onboardResults, setOnboardResults] = useState<any>([]);

    const validateGeids = () => {
        const requestHeaders: any = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };
        const baseUrl = '/p/flow';

        setIsValidatingGeids(true);
        setErrorMessage('');

        fetch(baseUrl + '/api/onboarding/validate', {
            headers: {
                ...requestHeaders,
                'Authorization': 'Bearer ' + User.getInstance().getAuthToken()
            },
            method: 'POST',
            body: JSON.stringify({geids})
        })
            .then(parseJSON)
            .then(response => {
                if (response.ok) {
                    setValidatedGeids(response.json);
                    setStep('2');
                } else {
                    throw Error('Error validating the passed GEIDs. Please try again');
                }
            })
            .catch((error) => {
                setErrorMessage(error?.message || 'Error validating the passed GEIDs. Please try again');
            })
            .finally(() => {
                setIsValidatingGeids(false);
            })
    }
    const initiateOnboarding = () => {

        const requestHeaders: any = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };
        const baseUrl = '/p/flow';

        setIsOnboarding(true);
        setErrorMessage('');

        fetch(baseUrl + '/api/onboarding', {
            headers: {
                ...requestHeaders,
                'Authorization': 'Bearer ' + User.getInstance().getAuthToken()
            },
            method: 'POST',
            body: JSON.stringify({employees: validatedGeids})
        })
            .then(parseJSON)
            .then(response => {
                if (response.ok) {
                    setStep('3');
                    setOnboardResults(response.json);
                } else {
                    throw Error('Error initiating on boarding. Please try again');
                }
            })
            .catch((error) => {
                setErrorMessage(error?.message || 'Error initiating on boarding. Please try again');
            })
            .finally(() => {
                setIsOnboarding(false);
            })
    }

    if (!User.getInstance().hasRole('el_onboarding_process_-_manual_initiate')) {
        return (
            <>
            <p><strong>You do not have access to this page</strong></p>
            </>
        );
    }

    return (
        <>
            {errorMessage && <Alert type={'danger'} message={errorMessage}/>}

            <h1>EL OnBoarding</h1>

            {step === '3' &&
            <>
                <table className="table table-sm table-bordered">
                    <thead>
                    <tr>
                        <th>GEID</th>
                        <th>Name</th>
                        <th>Position</th>
                        <th>Manager</th>
                        <th>Status</th>
                    </tr>
                    </thead>
                    <tbody>
                    {onboardResults.map(employee => (
                        employee.isValid ?
                            <tr>
                                <td>{employee.geid}</td>
                                <td>{employee.name}</td>
                                <td>{employee.position}</td>
                                <td>{employee.manager}</td>
                                <td><span className={employee.success ? 'text-success' : 'text-danger'}>{employee.success ? 'Success' : 'Failed'}</span></td>
                            </tr>
                            :
                            <tr>
                                <td>{employee.geid}</td>
                                <td colSpan={3}>{employee?.message || 'NO EMPLOYEE FOUND'}</td>
                                <td><span className="text-secondary">Skipped</span></td>
                            </tr>
                    ))}
                    </tbody>
                </table>
                <button type="button"
                        className="btn btn-secondary ml-2 mt-2"
                        disabled={isOnboarding}
                        onClick={() => {
                            setOnboardResults([]);
                            setValidatedGeids([]);
                            setStep('1');
                            setGeids('');
                        }}
                >Start Over
                </button>
            </>
            }

            {step === '2' &&
                <>
                    <table className="table table-sm table-bordered">
                        <thead>
                        <tr>
                            <th>GEID</th>
                            <th>Name</th>
                            <th>Position</th>
                            <th>Manager</th>
                        </tr>
                        </thead>
                        <tbody>
                        {validatedGeids.map(employee => (
                            employee.isValid ?
                                <tr>
                                    <td>{employee.geid}</td>
                                    <td>{employee.name}</td>
                                    <td>{employee.position}</td>
                                    <td>{employee.manager}</td>
                                </tr>
                                :
                                <tr>
                                    <td>{employee.geid}</td>
                                    <td colspan={3}>{employee?.message || 'NO EMPLOYEE FOUND'}</td>
                                </tr>
                        ))}
                        </tbody>
                    </table>
                    <ActivityButton
                        className="btn btn-primary mt-2"
                        isActive={isOnboarding}
                        disabled={isOnboarding}
                        onClick={() => {
                            initiateOnboarding();
                        }}
                    >Onboard Employees</ActivityButton>
                    <button type="button"
                            className="btn btn-secondary ml-2 mt-2"
                            disabled={isOnboarding}
                            onClick={() => {
                                setValidatedGeids([]);
                                setStep('1');
                            }}
                    >Start Over
                    </button>
                </>
            }
                {step === '1' &&
                <>
                    <p>Enter GEID(s) of employee(s) for which you want to initiate the EL Onboarding Process for. Enter one GEID on each line.</p>
                    <div style={{width: '400px'}}>
                <textarea
                    rows={5}
                    className="form-control"
                    disabled={isValidatingGeids}
                    value={geids}
                    onChange={(e) => {
                        setGeids(e.target.value);
                    }}
                />
                        <ActivityButton type="button"
                                        className="btn btn-primary mt-2"
                                        disabled={isValidatingGeids || geids?.length < 1}
                                        isActive={isValidatingGeids}
                                        onClick={validateGeids}
                        >Continue
                        </ActivityButton>
                    </div>
                </>
            }
        </>
    )
}